import React from 'react';
import { TextInput, SimpleForm } from 'react-admin';

const WorkerTagForm = (props) => {
    return (
        <SimpleForm {...props}>
            <TextInput source="name" />
        </SimpleForm>
    );
};

export default WorkerTagForm;
